import Grid from '@mui/material/Grid';
import React from 'react';
import { DataErrorHandler } from '../../../../../../components/ErrorHandler';
import { Loading, Workspace } from '../../../../../../design-system';
import { useCard } from '../Provider';
import { Details } from './components/Details';
import { Header } from './components/Header';

const OverviewView: React.FC = () => {
  const { card, error, loading, refetch } = useCard();

  if (loading) {
    return (
      <Workspace>
        <Loading />
      </Workspace>
    );
  }

  if (error || !card) {
    return <DataErrorHandler description="Unable to load card" error={error} refetch={refetch} />;
  }

  return (
    <Workspace>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Header card={card} />
        </Grid>
        <Grid item xs={12}>
          <Details card={card} />
        </Grid>
      </Grid>
    </Workspace>
  );
};

export default OverviewView;
